import React, { FunctionComponent, useMemo } from 'react';

import footer from 'components/lexemes/footer';
import interfaceLanguages from 'lib/languages.json';

import Select from 'components/select/select';

type externaLanguageListItem = {
  title: string;
  value: string;
  href?: string;
};

type Props = {
  lang: string;
  onChange?: (lang: string) => void;
  externaLanguageList?: externaLanguageListItem[];
};

const LanguageSelector: FunctionComponent<Props> = ({ lang, onChange, externaLanguageList }) => {
  const languagesList = useMemo(() => {
    return interfaceLanguages.map(({ name, code }) => ({
      title: name,
      value: code,
      href: `/${code}`,
    }));
  }, []);

  return (
    <Select
      onChange={onChange}
      defaultValue={lang}
      options={externaLanguageList || languagesList}
      hasMaxHeight={true}
      a11y={{
        label: footer.lxLanguageSelection(),
      }}
    />
  );
};

export default LanguageSelector;
